module.exports = __webpack_public_path__ + "static/media/hero2.f8b058d8.jpg";